<script setup lang="ts">
// Assuming useCartStore is auto-imported, otherwise import it here
interface ShopProps {
  id: number;
  name: string;
  type: string;
  address: string;
  bannerUrl: string;
  openTime?: string | null;
  closeTime?: string | null;
}

const props = withDefaults(defineProps<ShopProps>(), {
  openTime: "N/A",
  closeTime: "N/A",
});
const authStore = useAuthStore();
const dynamicPath = '/shops/' + props.id;
</script>

<template>
  <div class="card bg-base-100 shadow-md hover:shadow-2xl transition-all duration-300 mb-3 h-full flex flex-col group border border-base-200/50">
    
    <figure class="h-40 sm:h-48 w-full overflow-hidden relative shrink-0">
      <img
        :src="bannerUrl"
        :alt="name"
        class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
      >
      <div class="absolute inset-0 bg-linear-to-t from-black/10 to-transparent"/>
    </figure>

    <div class="card-body p-4 sm:p-6 grow flex flex-col gap-3">
      
      <div class="flex flex-col sm:flex-row sm:items-start justify-between gap-2">
          <div class="flex justify-between items-start">
            <h2 class="card-title text-xl font-bold text-primary">{{name}}</h2>
            <!-- <div class="badge badge-sm badge-primary badge-outline">{{type}}</div> -->
          </div>
      </div>

      <div class="flex flex-col gap-2 grow mt-1">
        <div class="flex items-start gap-2 text-sm text-base-content/70">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4 sm:size-5 shrink-0 text-primary mt-0.5">
            <path fill-rule="evenodd" d="M9.69 18.933l.003.001C9.89 19.02 10 19 10 19s.11.02.308-.066l.002-.001.006-.003.018-.008a5.741 5.741 0 00.281-.14c.186-.096.446-.24.757-.433.62-.384 1.445-.966 2.274-1.765C15.302 14.988 17 12.493 17 9A7 7 0 10 3 9c0 3.492 1.698 5.988 3.355 7.62.829.799 1.654 1.381 2.274 1.766.311.192.571.337.757.433.093.048.17.087.23.117.029.015.053.027.072.036l.024.011.005.002zM7 9a3 3 0 116 0 3 3 0 01-6 0z" clip-rule="evenodd" />
          </svg>
          <span class="line-clamp-2 leading-snug">{{ address }}</span>
        </div>
        
        <div class="flex items-center gap-2 text-sm font-medium">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4 sm:size-5 text-primary shrink-0">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-13a.75.75 0 00-1.5 0v5c0 .414.336.75.75.75l4 1a.75.75 0 10.375-1.468l-3.625-.906V5z" clip-rule="evenodd" />
          </svg>
          <span class="text-base-content/80">
            {{ openTime }} - {{ closeTime }}
          </span>
        </div>
      </div>

      <div class="card-actions justify-end mt-4 shrink-0">
        <NuxtLink 
          :to="dynamicPath" 
          class="btn btn-primary btn-sm sm:btn-md w-full text-white"
          @click="authStore.setShopId(props.id)"
        >
          Visit Shop
        </NuxtLink>
      </div>
      
    </div>
  </div>
</template>